import React, { Component } from "react";
import KpsListItem from "../../core-elements/KpsListItem";
import ListItemText from "@material-ui/core/ListItemText";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import Table from "@material-ui/core/Table";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router";
import DisplayUser from "../../components/user/DisplayUser";
import moment from "moment";
import KpsEditor from "../editor/KpsEditor";
import Paper from "@material-ui/core/Paper";
import SmsFailedIcon from "@material-ui/icons/SmsFailed";
import ChatBubbleIcon from "@material-ui/icons/ChatBubble";
import Typography from "@material-ui/core/Typography";
import { Tooltip } from "@material-ui/core";
import { currentUserHasRole } from "../../utils/RoleUtils";
import DisplayLocation from "../taxonomy/discussions/DisplayLocation";
import DisplayExpertQuestionTemplate from "../expert-questions/DisplayExpertQuestionTemplate";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import SupervisedUserCircleIcon from "@material-ui/icons/SupervisedUserCircle";

const styles = (theme) => ({
  alert: {
    color: theme.palette.error.light,
  },
  iconSpan: {
    "& > svg": {
      verticalAlign: "middle",
    },
  },
  secondarySpan: {
    verticalAlign: "middle",
    // marginLeft: "5px"
  },
  myMessageInput: {
    color: "white",
    "&:before": {
      borderColor: "white",
    },
    "&:after": {
      borderColor: "white",
    },
  },
  otherMessageInput: {
    color: "black",
  },
  postSummary: {
    "& p": {
      display: "inline-block",
      maxWidth: 450,
      overflow: "hidden",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
    },
  },
  bubbleContainer: {
    display: "flex",
    alignSelf: "flex-end",
    flexGrow: 1,
    flex: 1,
    flexDirection: "row",
    width: "100%",
    justifyContent: "flex-start",
  },
  bubble: {
    padding: 0,
    backgroundColor: "#eee",
    display: "flex",
    borderRadius: "0px 30px 30px 30px",
    margin: 6,
    marginLeft: 30,
    paddingLeft: 10,
    paddingRight: 10,
    paddingTop: 2,
    paddingBottom: 2,
    maxHeight: "100px",
    // overflow: "auto",
    overflow: "hidden",
  },
  entryContainer: {
    marginLeft: theme.spacing(2),
  },
  discussionContainer: {
    display: "flex",
    alignItems: "center",
    "& div": {
      marginRight: theme.spacing(1),
    },
  },
  secondary: {
    display: "flex",
    alignItems: "center",
    marginLeft: theme.spacing(2),
  },
  lastPostDate: {
    marginLeft: theme.spacing(4),
  },
});
export class ItemEntries extends Component {
  static propTypes = {
    data: PropTypes.object.isRequired,
    setExtendedString: PropTypes.func.isRequired,
  };
  state = {
    extendedString: "",
    itemsInBubble: [
      "settings_entry_posted_by",
      "settings_discussions_date_last_post",
      "settings_entry_last_post_text",
    ],
  };
  componentDidMount() {
    this.setState({ discussion: this.props.data });
    this.extendedInfo(this.props.extendedSettings);
    this.defaultFullscreenInfo(this.props.fullscreenSettings);
  }
  componentDidUpdate(prevProps) {
    if (prevProps.extendedSettings !== this.props.extendedSettings) {
      this.extendedInfo(this.props.extendedSettings);
    }
  }
  renderTitle() {
    const { classes } = this.props;
    return (
      <>
        <div className={classes.discussionContainer}>
          <div>
            {this.props.data.discussionRead ? (
              <Tooltip
                title={
                  <Typography>
                    {this.props.t("required_reading_read")}
                  </Typography>
                }
              >
                <ChatBubbleIcon />
              </Tooltip>
            ) : (
              <Tooltip
                title={
                  <Typography>
                    {this.props.t("required_reading_unread")}
                  </Typography>
                }
              >
                <SmsFailedIcon className={classes.alert} />
              </Tooltip>
            )}
          </div>
          {this.props.data.genre === "EXPERT_QUESTION" && (
            <div>
              <Tooltip
                title={
                  <Typography>
                    {this.props.t("global_expert_question_singular") + 
                    " (" + 
                    this.props.t(this.props.data.expertQuestionVisibility.toLowerCase().replace("public_view_only","public_view")) + 
                    ") "}
                  </Typography>
                }
              >
                <SupervisedUserCircleIcon />
              </Tooltip>
            </div>
          )}
          <div>{this.props.data.title}</div>
        </div>
      </>
    );
  }
  renderBubbleAndTitle() {
    const { classes } = this.props;
    return (
      <>
        {this.renderTitle()}
        {this.renderBubble()}
      </>
    );
  }
  renderBubble() {
    const { classes } = this.props;
    let isObject = false;
    if (this.props.data) {
      try {
        let post = JSON.parse(this.props.data.lastPostText);
        isObject = post instanceof Object;
      } catch (x) {
        isObject = false;
      }
    }
    return (
      <>
        <div className={classes.entryContainer}>
          {this.props.fullscreen !== true && (
            <>
              <DisplayUser user={this.props.data.lastPoster} />
              <div className={classes.lastPostDate}>
                {moment(this.props.data.lastPostDate).format("LLL")}
              </div>
            </>
          )}
          <div className={classes.bubbleContainer}>
            <Paper
              elevation={3}
              className={classes.bubble}
              style={{
                backgroundColor:
                  this.props.data.lastPoster.userLogin ===
                  this.props.currentUser.userLogin
                    ? "#0048AA"
                    : "#eee",
                color:
                  this.props.data.lastPoster.userLogin ===
                  this.props.currentUser.userLogin
                    ? "white"
                    : "black",
              }}
            >
              {isObject === true ? (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                  }}
                >
                  {JSON.parse(this.props.data.lastPostText).map((section) => (
                    <DisplayExpertQuestionTemplate
                      inputClass={
                        this.props.data.lastPoster.userLogin ===
                        this.props.currentUser.userLogin
                          ? classes.myMessageInput
                          : classes.otherMessageInput
                      }
                      data={section}
                      changeValue={this.changeValue}
                    />
                  ))}
                </div>
              ) : (
                <div
                  className={classes.postSummary}
                  dangerouslySetInnerHTML={{
                    __html: this.props.data.lastPostText,
                  }}
                />
              )}
            </Paper>
          </div>
        </div>
      </>
    );
  }
  render() {
    const { classes } = this.props;
    return (
      <KpsListItem
        extendedString={this.state.extendedString}
        preText={this.props.preText}
        provided={this.props.provided}
        onItemClick={
          this.props.discussionPortlet
            ? this.onItemClick
            : () => this.props.onItemClick(this.props.data)
        }
        fullscreen={this.props.fullscreen}
        fullscreenSettings={
          this.props.fullscreenSettings &&
          this.props.fullscreenSettings !== null
            ? JSON.parse(this.props.fullscreenSettings).map((setting, idx) => {
                return <>{this.getSettingInfo(setting)}</>;
              })
            : this.state.defaultFullscreen
        }
      >
        {this.props.preText}
        <ListItemText
          primary={
            this.props.fullscreen
              ? this.renderTitle()
              : this.renderBubbleAndTitle()
          }
          secondary={""}
          style={{ overflowWrap: "anywhere" }}
        />
      </KpsListItem>
    );
  }

  onItemClick = () => {
    this.props.data.type === "DOCUMENT"
      ? this.props.history.push({
          pathname: `/full/document/${this.props.data.itemId}`,
          state: { discussionId: this.props.data.discussionId },
        })
      : this.props.data.type === "KNOWLEDGE_ITEM"
        ? this.props.history.push({
            pathname: `/full/knowledgeitem/${this.props.data.itemId}`,
            state: { discussionId: this.props.data.discussionId },
          })
        : this.props.history.push({
            pathname: `/full/discussion/${this.props.data.discussionId}`,
            state: { discussionId: this.props.data.discussionId },
          });
  };
  defaultFullscreenInfo(settings) {
    if (!settings || settings.length === 0) {
      settings = [];
      for (let i = 0; i < this.props.discussionEntryOptions.length; i++) {
        settings.push({
          label: this.props.discussionEntryOptions[i],
          order: i,
        });
      }
    } else {
      try {
        let jsonsettings = JSON.parse(settings);
        settings = jsonsettings;
      } catch (x) {
        settings = [{ label: settings, order: 0 }];
      }
    }
    var fullScreenString = (
      <>
        {settings.map((setting, idx) => {
          return <>{this.getSettingInfo(setting)}</>;
        })}
      </>
    );
    this.setState({ defaultFullscreen: fullScreenString });
  }
  getSettingInfo = (setting) => {
    return (
      <>
        {setting.label === "settings_entry_last_post_text" && (
          <TableCell>{this.renderBubble()}</TableCell>
        )}
        {setting.label === "settings_entry_posted_by" && (
          <TableCell>
            <DisplayUser
              userId={this.props.data.lastPoster.userId}
              user={this.props.data.lastPoster}
            />
          </TableCell>
        )}
        {setting.label === "settings_discussions_location" && (
          <TableCell>
            {
              <DisplayLocation
                type={this.props.data.type}
                itemId={this.props.data.itemId}
                topicId={this.props.data.topicId}
                title={this.props.data.targetTitle}
              />
            }
          </TableCell>
        )}
        {setting.label === "settings_discussions_date_created" && (
          <TableCell>
            {!!this.props.data.time
              ? moment(this.props.data.time).format("LLL")
              : "n/a"}
          </TableCell>
        )}
        {setting.label === "settings_discussions_number_posts" && (
          <TableCell>{this.props.data.numberOfEntries}</TableCell>
        )}
        {setting.label === "settings_discussions_number_views" && (
          <TableCell>
            {this.props.data.views ? this.props.data.views : 0}
          </TableCell>
        )}
        {setting.label === "settings_discussions_date_last_post" && (
          <TableCell>
            {moment(this.props.data.lastPostDate).format("LLL")}
          </TableCell>
        )}
        {setting.label === "settings_expert_question_status" && (
          <TableCell>
            {this.props.data.locked
              ? this.getLockedIconAndTooltip()
              : this.props.data.expertQuestionStatus}
          </TableCell>
        )}
        {setting.label === "settings_expert_question_visibility" && (
          <TableCell>{this.props.data.expertQuestionVisibility}</TableCell>
        )}
      </>
    );
  };
  extendedInfo(settings) {
    const { classes } = this.props;
    if (!settings) {
      settings = [];
      for (let i = 0; i < this.props.discussionEntryOptions.length; i++) {
        settings.push({
          label: this.props.discussionEntryOptions[i],
          order: i,
        });
      }
    } else {
      settings = JSON.parse(settings);
    }

    var extendedString = (
      <>
        {settings.map((setting, idx) => {
          return (
            <>
              {this.state.itemsInBubble.indexOf(setting.label) === -1 && (
                <TableRow key={idx}>
                  <TableCell>{this.props.t(setting.label)}</TableCell>
                  {this.getSettingInfo(setting)}
                </TableRow>
              )}
            </>
          );
        })}
      </>
    );
    this.setState({ extendedString });
  }
}
const mapStateToProps = (state) => ({
  discussionEntryOptions: state.selectionOption.discussionEntrySettingsOptions,
  currentUser: state.user.currentUser,
});
export default connect(
  mapStateToProps,
  null
)(withStyles(styles)(withRouter(withTranslation()(ItemEntries))));
